module.exports = __webpack_public_path__ + "static/adobestock_221763351-d8b29670384b93de8857a42639cb74e3.jpeg";